/**
 * List-row owner colours. Core staff are pinned so the people you see every
 * day never hash to the same wash. Everyone else uses a spread djb2 index.
 */

import { normalizeOwnerDisplayName, ownerKey } from './nameNormalization';
import { CANONICAL_JASON_HOLDSWORTH_UID, resolveCanonicalOwnerUid } from './ownerIdentity';

export const USER_AVATAR_PALETTE = [
  'bg-green-200 text-green-800',
  'bg-accent-200 text-accent-800',
  'bg-warning-200 text-warning-800',
  'bg-purple-200 text-purple-800',
  'bg-error-200 text-error-800',
  'bg-primary-200 text-primary-800',
  'bg-pink-200 text-pink-800',
  'bg-sky-200 text-sky-800',
] as const;

/** Known team members: one reserved slot each, keyed by canonical uid or name. */
const STAFF_AVATAR_INDEX: Readonly<Record<string, number>> = {
  [CANONICAL_JASON_HOLDSWORTH_UID]: 0,
  'jason holdsworth': 0,
  SshCa3IIk1Mi5DfkrmzDa6MBlpv1: 1,
  'charlie streeter': 1,
  ZpzG6t8pfqe3W6XyC8M9QuxgeFk1: 2,
  'camille hardman': 2,
  b7Vra7u8mVT506wvAVJTCvrGRpB3: 3,
  'matt a': 3,
  XM3ZEAyTDQRIWKoFDBmOz5fVnMD2: 4,
  'adrien monet': 4,
  xjxSqMdaGBVpGaZJiBV1WE1L2Ym2: 5,
  'william lawson': 5,
  IThfryIKaZduNpllb4cfiP77HaH2: 6,
  'matt chalmers': 6,
};

export function hashAvatarColorIndex(seed: string): number {
  let hash = 5381;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 33) ^ seed.charCodeAt(i);
  }
  return Math.abs(hash) % USER_AVATAR_PALETTE.length;
}

function staffColorIndex(seed: string): number | undefined {
  const canonical = resolveCanonicalOwnerUid(seed, seed);
  if (Object.prototype.hasOwnProperty.call(STAFF_AVATAR_INDEX, canonical)) {
    return STAFF_AVATAR_INDEX[canonical];
  }
  const nameKey = ownerKey(normalizeOwnerDisplayName(seed));
  if (nameKey && Object.prototype.hasOwnProperty.call(STAFF_AVATAR_INDEX, nameKey)) {
    return STAFF_AVATAR_INDEX[nameKey];
  }
  return undefined;
}

export function getUserAvatarColor(seed: string): string {
  const pinned = staffColorIndex(seed);
  if (pinned !== undefined) return USER_AVATAR_PALETTE[pinned];
  const canonical = resolveCanonicalOwnerUid(seed, seed);
  return USER_AVATAR_PALETTE[hashAvatarColorIndex(canonical || seed)];
}
